"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _appendCss = _interopRequireDefault(require("../utils/appendCss"));
var _Chips_css = _interopRequireDefault(require("./Chips_css"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
class Chips extends _react.Component {
  constructor(props) {
    super(props);
    (0, _appendCss.default)("arc_chips", _Chips_css.default);
    this.handleClick = this.handleClick.bind(this);
  }
  handleClick(chip) {
    if (chip.disabled === true) return;
    let newChipState = chip;
    newChipState.selected = !chip.selected;
    this.props.onClick(newChipState);
  }
  render() {
    const {
      className,
      list,
      themeColor
    } = this.props;
    return /*#__PURE__*/_react.default.createElement("div", {
      className: `chips__list ${themeColor}-color ${className}`
    }, list.map((chip, i) => {
      return /*#__PURE__*/_react.default.createElement("button", {
        key: `chip-item-${i}`,
        type: "button",
        className: `chips__elem t-label-large ${chip.selected && "selected"}`,
        disabled: chip.disabled,
        value: chip.id,
        "aria-label": chip.label,
        onClick: () => this.handleClick(chip)
      }, /*#__PURE__*/_react.default.createElement("span", null, chip.label));
    }));
  }
}
exports.default = Chips;
Chips.propTypes = {
  /** Array of chips to display */
  list: _propTypes.default.arrayOf(_propTypes.default.shape({
    id: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]).isRequired,
    label: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,
    selected: _propTypes.default.bool.isRequired,
    disabled: _propTypes.default.bool
  })),
  /** onClick event handler */
  onClick: _propTypes.default.func,
  /** Additional classes for chips */
  className: _propTypes.default.string,
  /** Theme color variant [primary, accent, error, success] */
  themeColor: _propTypes.default.oneOf(["primary", "accent", "error", "success"])
};
Chips.defaultProps = {
  className: "",
  list: [],
  themeColor: "primary"
};